module.exports = __webpack_public_path__ + "static/media/20240816_131439.b668d0e8.jpg";